import { useModal } from "@ebay/nice-modal-react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";

import FormDescriptionField from "components/Environment/components/FormItems/DescriptionField";
import FormIsSecretField from "components/Environment/components/FormItems/IsSecretField";
import FormPathField from "components/Environment/components/FormItems/PathField";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerFooter from "ds/components/Drawer/Footer";
import DrawerFooterActions from "ds/components/Drawer/FooterActions";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCancelButton from "ds/components/DrawerNew/CancelButton";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerForm from "ds/components/DrawerNew/Form";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import { ConfigType } from "types/generated";
import { getDrawerFormFix } from "utils/css";

import { ContextMountedFilesFormDrawerProps, ContextVariablesFormFields } from "./types";

const ContextMountedFilesFormDrawer = createDrawer(
  ({ handleFileAdd, item }: ContextMountedFilesFormDrawerProps) => {
    const fileForm = useForm<ContextVariablesFormFields>({
      defaultValues: {
        id: item?.id || "",
        description: item?.description || "",
        writeOnly: item?.writeOnly ? item.writeOnly : true,
        type: ConfigType.FileMount,
      },
      mode: "onChange",
    });

    const drawer = useModal();

    const {
      handleSubmit,
      formState: { isDirty },
    } = fileForm;

    const closeDrawer = () => {
      drawer.resolve();
      drawer.hide();
    };

    const onCreateSubmit = (formData: ContextVariablesFormFields) => {
      const fileData = {
        id: formData.id,
        description: formData.description || "",
        writeOnly: formData.writeOnly,
        type: formData.type,
        isDraft: true,
        createdAt: null,
        value: null,
      };
      handleFileAdd(fileData);
      closeDrawer();
    };

    const onSubmit: SubmitHandler<ContextVariablesFormFields> = (formData) => {
      onCreateSubmit(formData);
    };

    return (
      <DrawerForm isDirty={isDirty}>
        <FormProvider {...fileForm}>
          <form onSubmit={handleSubmit(onSubmit)} {...getDrawerFormFix()}>
            <DrawerHeader justify="between">
              <DrawerHeaderTitle title="Add file" />
              <DrawerCloseIcon />
            </DrawerHeader>
            <DrawerBody fullHeight>
              <Box margin="0 0 large">
                <FormPathField name="id" />
              </Box>
              <FormIsSecretField name="writeOnly" />
              <FormDescriptionField name="description" />

              <DrawerFooter>
                <DrawerFooterActions>
                  <DrawerCancelButton />
                  <Button variant="primary" type="submit">
                    {item ? "Save" : "Continue"}
                  </Button>
                </DrawerFooterActions>
              </DrawerFooter>
            </DrawerBody>
          </form>
        </FormProvider>
      </DrawerForm>
    );
  }
);

export const showContextMountedFilesFormDrawer = createDrawerTrigger(ContextMountedFilesFormDrawer);
